// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.img-ykbut2{
  width: 100%;
  height: 100%;
  position: fixed;
  background-position: center;
  margin-top: -0% !important;
  
}

/* Gaya asli untuk layar desktop */
.wrapper-3 {
width: 350px;
height: 90%;
margin: 80px auto;
padding: 40px 30px 30px 30px;
background-color: #fff;
border-radius: 15px;
box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
margin-top: 5px;
position: relative;
padding: 20px;
overflow: auto !important;
}

.wrapper-3 .btn {
display: inline-block;
height: 8%;
margin-top: 12% !important;
justify-content: center;
display: flex;
background-color: #176B87;
color: #fff;
border: 2px solid rgb(8, 96, 128);
border-radius: 6px;
border: 2px;
padding: 8px;
margin: 5px;
font-size: 14px;
font-family: 'Poppins';
font-weight: 900;
cursor: pointer;
width: 96%;
}

/* Gaya untuk layar iPad */
@media screen and (min-width: 768px) and (max-width: 1024px) {
.wrapper-3 {
    width: 60%; /* Sesuaikan lebar sesuai kebutuhan untuk layar iPad */
    margin: 50px auto;
}

.wrapper-3 .btn {
  font-size: 17px;
  margin-top: 5% !important;
  width: 50%;
  height: 5%;
  margin-left: 25%;
}
}

/* Gaya untuk layar mobile */
@media screen and (max-width: 767px) {
.wrapper-3 {
    width: 90%; /* Sesuaikan lebar sesuai kebutuhan untuk layar mobile */
    margin: 30px auto;
    padding: 20px;
}

.wrapper-3 .btn {
    height: auto; /* Sesuaikan tinggi sesuai kebutuhan untuk layar mobile */
    margin-top: 5% !important;
}
}



.tentang{
  text-align: center;
  font-size: 23px !important;
  font-family: 'Poppins' !important;
  color: black;
}

.description{
  margin-top: 10% !important;
  color: black;
  font-family: 'Poppins' !important;
  text-align: justify;
  
}

.privacy{
  text-align: center;
  font-size: 23px !important;
  font-family: 'Poppins' !important;
  color: white;
  margin-top: 10% !important;
}

.description-2{
  margin-top: 10% !important;
  color: white;
  font-family: 'Poppins' !important;
}

.back-icon-set{
  color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/components/Settings/Settings.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,0BAA0B;;AAE5B;;AAEA,kCAAkC;AAClC;AACA,YAAY;AACZ,WAAW;AACX,iBAAiB;AACjB,4BAA4B;AAC5B,sBAAsB;AACtB,mBAAmB;AACnB,wCAAwC;AACxC,eAAe;AACf,kBAAkB;AAClB,aAAa;AACb,yBAAyB;AACzB;;AAEA;AACA,qBAAqB;AACrB,UAAU;AACV,0BAA0B;AAC1B,uBAAuB;AACvB,aAAa;AACb,yBAAyB;AACzB,WAAW;AACX,iCAAiC;AACjC,kBAAkB;AAClB,WAAW;AACX,YAAY;AACZ,WAAW;AACX,eAAe;AACf,sBAAsB;AACtB,gBAAgB;AAChB,eAAe;AACf,UAAU;AACV;;AAEA,0BAA0B;AAC1B;AACA;IACI,UAAU,EAAE,sDAAsD;IAClE,iBAAiB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,UAAU;EACV,UAAU;EACV,gBAAgB;AAClB;AACA;;AAEA,4BAA4B;AAC5B;AACA;IACI,UAAU,EAAE,wDAAwD;IACpE,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,YAAY,EAAE,yDAAyD;IACvE,yBAAyB;AAC7B;AACA;;;;AAIA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;EACjC,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,WAAW;AACb","sourcesContent":[".img-ykbut2{\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  background-position: center;\n  margin-top: -0% !important;\n  \n}\n\n/* Gaya asli untuk layar desktop */\n.wrapper-3 {\nwidth: 350px;\nheight: 90%;\nmargin: 80px auto;\npadding: 40px 30px 30px 30px;\nbackground-color: #fff;\nborder-radius: 15px;\nbox-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\nmargin-top: 5px;\nposition: relative;\npadding: 20px;\noverflow: auto !important;\n}\n\n.wrapper-3 .btn {\ndisplay: inline-block;\nheight: 8%;\nmargin-top: 12% !important;\njustify-content: center;\ndisplay: flex;\nbackground-color: #176B87;\ncolor: #fff;\nborder: 2px solid rgb(8, 96, 128);\nborder-radius: 6px;\nborder: 2px;\npadding: 8px;\nmargin: 5px;\nfont-size: 14px;\nfont-family: 'Poppins';\nfont-weight: 900;\ncursor: pointer;\nwidth: 96%;\n}\n\n/* Gaya untuk layar iPad */\n@media screen and (min-width: 768px) and (max-width: 1024px) {\n.wrapper-3 {\n    width: 60%; /* Sesuaikan lebar sesuai kebutuhan untuk layar iPad */\n    margin: 50px auto;\n}\n\n.wrapper-3 .btn {\n  font-size: 17px;\n  margin-top: 5% !important;\n  width: 50%;\n  height: 5%;\n  margin-left: 25%;\n}\n}\n\n/* Gaya untuk layar mobile */\n@media screen and (max-width: 767px) {\n.wrapper-3 {\n    width: 90%; /* Sesuaikan lebar sesuai kebutuhan untuk layar mobile */\n    margin: 30px auto;\n    padding: 20px;\n}\n\n.wrapper-3 .btn {\n    height: auto; /* Sesuaikan tinggi sesuai kebutuhan untuk layar mobile */\n    margin-top: 5% !important;\n}\n}\n\n\n\n.tentang{\n  text-align: center;\n  font-size: 23px !important;\n  font-family: 'Poppins' !important;\n  color: black;\n}\n\n.description{\n  margin-top: 10% !important;\n  color: black;\n  font-family: 'Poppins' !important;\n  text-align: justify;\n  \n}\n\n.privacy{\n  text-align: center;\n  font-size: 23px !important;\n  font-family: 'Poppins' !important;\n  color: white;\n  margin-top: 10% !important;\n}\n\n.description-2{\n  margin-top: 10% !important;\n  color: white;\n  font-family: 'Poppins' !important;\n}\n\n.back-icon-set{\n  color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
